module.exports = __webpack_public_path__ + "img/login-v2-1.9b7c66fd.png";